<template>
  <div class="relative w-full">
    <!-- Icon inside input (left) -->
    <i
      v-if="icon"
      :class="`bi ${icon}`"
      class="absolute left-3 top-1/2 -translate-y-1/2 text-base text-base-content/50 z-10 pointer-events-none"
    ></i>

    <!-- Input -->
    <input
      type="text"
      :placeholder="placeholder"
      :maxlength="maxLength"
      v-model="modelValue"
      :class="[
        'input input-bordered w-full text-sm placeholder-base-300 focus:border-accent focus:border-2 focus:outline-none',
        icon ? 'pl-10' : ''
      ]"
      :disabled="disabled"
    />

    <!-- Character Counter -->
    <span
      class="text-xs text-base-content/50 mt-1 ms-2 block"
      v-if="withSpan"
    >
      Characters {{ modelValue?.length || 0 }}/{{ maxLength }}
    </span>
  </div>
</template>

<script setup>

defineProps({
  withSpan: { type: Boolean, default: true },
  placeholder: { type: String, default: 'Enter a description...' },
  maxLength: { type: Number, default: 100 },
  icon: { type: String, default: null },
  disabled: { type: Boolean, default: false }
})

const modelValue = defineModel()
</script>